import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_1T: TStep[] = [
  {
    pageId: PageId.START_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_1_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_2_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_3_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_4_INTL_1T,
  },
  {
    pageId: PageId.SPEED_FEEDBACK_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_5_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_6_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_7_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_8_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_9_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_10_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_11_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_12_INTL_1T,
  },
  {
    pageId: PageId.SMARTNESS_FEEDBACK_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_13_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_14_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_15_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_16_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_17_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_18_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_19_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_20_INTL_1T,
  },
  {
    pageId: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_21_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_22_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_23_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_24_INTL_1T,
  },
  {
    pageId: PageId.QUESTION_25_INTL_1T,
  },
  {
    pageId: PageId.AGE_QUESTION_INTL_1T,
  },
  {
    pageId: PageId.EDUCATION_QUESTION_INTL_1T,
  },
  {
    pageId: PageId.DISCOVER_FEEDBACKS_INTL_1T,
  },
  {
    pageId: PageId.PREPARE_FLOW_INTL_1T,
  },
  {
    pageId: PageId.EMAIL_INTL_1T,
  },
  {
    pageId: PageId.OFFER_INTL_1T,
  },
  {
    pageId: PageId.PAYMENT_INTL_1T,
  },
  {
    pageId: PageId.REGISTRATION_INTL_1T,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_1T,
  },
  {
    pageId: PageId.CERTIFICATE_INTL_1T,
  },
  {
    pageId: PageId.REPORT_INTL_1T,
  },
]
